import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import BaseShortcutKeyManager from '../base/manager';
import { ShortcutActionName } from '../constants';
import { IPcActionsInjectable, IPcShortcutKeyManager, IPcShortcutKeyManagerInjectable, IPcShortcutKeyServices } from '../interface';
import PcShortcutActions from './actions';

export default class PcShortcutKeyManager extends BaseShortcutKeyManager implements IPcShortcutKeyManager {
    protected declare services: IPcShortcutKeyServices;
    // manager 自身的异化逻辑
    protected readonly injectable?: IPcShortcutKeyManagerInjectable;
    // action 的异化逻辑
    protected readonly actionsInjectable?: IPcActionsInjectable;

    public constructor(injectable?: IPcShortcutKeyManagerInjectable, actionsInjectable?: IPcActionsInjectable) {
        super(injectable, actionsInjectable);
        this.injectable = injectable;
        this.actionsInjectable = actionsInjectable;
    }
    protected getCtrlKey() {
        return browser.isMac ? 'command' : 'ctrl';
    }

    protected getShortcutConfig() {
        const ctrl = this.getCtrlKey();
        const shortcutConfig = {
            ...super.getShortcutConfig(),
            [`${ctrl}+i`]: this.handleAction.bind(this, ShortcutActionName.ITALIC),
            [`${ctrl}+b`]: this.handleAction.bind(this, ShortcutActionName.BOLD),
            [`${ctrl}+u`]: this.handleAction.bind(this, ShortcutActionName.UNDERLINE),
            [`${ctrl}+d`]: this.handleAction.bind(this, ShortcutActionName.DELETE_LINE),
            [`${ctrl}+f`]: this.handleAction.bind(this, ShortcutActionName.SEARCH),
            [`${ctrl}+h`]: this.handleAction.bind(this, ShortcutActionName.REPLACE),
            [`${ctrl}+k`]: this.handleAction.bind(this, ShortcutActionName.LINK),
            [`${ctrl}+f1`]: this.handleAction.bind(this, ShortcutActionName.HIDE_SHOW_TOP_BAR),
            ['alt+f9']: this.handleAction.bind(this, ShortcutActionName.DISPLAY_GUIDES),
            ['shift+f9']: this.handleAction.bind(this, ShortcutActionName.DISPLAY_GRID_LINE),
            // 无障碍快捷键入口ctrl+·，windows为ctrl+·，mac为control+·
            ['ctrl+`']: this.handleAction.bind(this, ShortcutActionName.ACCESSIBILITY),
            [`${ctrl}+alt+m`]: this.handleAction.bind(this, ShortcutActionName.INSERT_COMMENT), // 批注
        };

        if (browser.isSafari && browser.isSafariVersionBelow(14)) {
            shortcutConfig[`${ctrl}+c`] = this.handleAction.bind(this, ShortcutActionName.COPY);
            // shortcutConfig[`${ctrl}+v`] = this.handleAction.bind(this, ShortcutActionName.PASTE);
            shortcutConfig[`${ctrl}+x`] = this.handleAction.bind(this, ShortcutActionName.CUT);
            shortcutConfig[`${ctrl}`] = this.handleAction.bind(this, ShortcutActionName.CTRL);
        }

        if (browser.isMac) {
            shortcutConfig['ctrl+option+command+g'] = this.handleAction.bind(this, ShortcutActionName.DISPLAY_GUIDES);
            shortcutConfig['command+\''] = this.handleAction.bind(this, ShortcutActionName.DISPLAY_GRID_LINE);
            shortcutConfig['alt+f9'] = () => {};
            shortcutConfig['shift+f9'] = () => {};
        }

        return shortcutConfig;
    }
    protected getBubblingShortcutConfig() {
        const ctrl = this.getCtrlKey();
        return {
            ...super.getBubblingShortcutConfig(),
            esc: this.handleAction.bind(this, ShortcutActionName.ESC),
            [`${ctrl}+f`]: this.handleAction.bind(this, ShortcutActionName.SEARCH),
            [`${ctrl}+/`]: this.handleAction.bind(this, ShortcutActionName.SHORTCUTPANEL),
            ...this.handleExtraBubbleKeyConfig(),
        };
    }

    protected createShortcutActions() {
        return new PcShortcutActions(this.services, this.actionsInjectable);
    }

    private handleExtraBubbleKeyConfig() {
        const extraBubbleKeyConfig = this.injectable?.getExtraBubbleKeyConfig();
        if (extraBubbleKeyConfig) {
            const result = {};
            extraBubbleKeyConfig.forEach((config) => {
                result[config.key] = this.handleAction.bind(this, config.actionKey);
            });
            return result;
        }
        return null;
    }
}
